import {TranslateService} from "@ngx-translate/core";

export class MetaPropertySchema {
	constructor() {
		if (!this.display) {
			this.display = {
				patternErrorMessage: {},
				placeholder: {},
				type: 'text',
				inputMask: null,
				tooltipMessage: {},
				multiple: false
			}
		}
	}
	public translateService: TranslateService;
	id: number;
	requiredOnForm: boolean;
	name: string;
	pattern: string;
	usedOnForm: boolean;
	binary: boolean;
	ordering: number;
	description: string;
	add_to_token: boolean;
	used_for_login: boolean;
	part_of_verified_user: boolean;
	un_deletable:boolean;
	unique: boolean;
	display: {
		patternErrorMessage: {},
		placeholder: {},
		type: string,
		inputMask: string,
		tooltipMessage: {},
		multiple: boolean
	};
	invalidating_properties: any[];
	verified: boolean;
	getNormalizedForSave() {
		if (this.display && this.name === 'password') {
			this.display.type = 'password'
		}
		return {
			id: this.id,
			requiredOnForm: this.requiredOnForm,
			name: this.name,
			pattern: this.pattern,
			usedOnForm: this.usedOnForm,
			binary: (this.display && this.display.type === 'file') || this.binary,
			ordering: this.ordering,
			description: this.description,
			add_to_token: this.add_to_token,
			used_for_login: this.used_for_login,
			part_of_verified_user: this.part_of_verified_user,
			un_deletable: this.un_deletable,
			unique: this.unique,
			invalidating_properties: this.invalidating_properties,
			display: JSON.stringify(this.display),
			verified: this.verified
		}
	};
	get label(): string {
		let label = this.display && this.display.placeholder && this.display.placeholder[(this.translateService && this.translateService.currentLang) || "en"];
		return label || this.name;
	};
	getPatternErrorMessage(langCode :string) {
		return (this.display && this.display.patternErrorMessage && this.display.patternErrorMessage[langCode]) || "";
	}
}
